<div class="w-p-100 h-p-100 flex flex-row flex-1-0-auto">
  <div class="dew-dates-widget-container h-p-100 p-t-30 flex flex-row full-grow-no-shrink-no-basis ">
    <particle-shimmer-loader
      [elemCount]="1"
      [elemWidth]="375"
      [elemHeight]="500"
      [elemPadding]="10"
      [elemMargin]="10"
      [isVisible]="!dataLoaded"
    ></particle-shimmer-loader>

    <div *ngIf="(hasData$|async) && dataLoaded" class="flex flex-col full-grow-no-shrink-no-basis ">
      <div class="p-lr-30">
        <div class="blue-box-container">
          <span>Note:</span> Displaying compliance deadlines for the next 60 days ({{fromDate | date :'longDate'}} to
          {{toDate | date :'longDate'}}).
        </div>
      </div>


      <div class="pos-relative m-tb-30 m-lr-30 flex flex-col full-grow-no-shrink-no-basis ">
        <div class="keno-grid-container">
          <particle-virtual-grid [sourceKey]="sourceKey">
          </particle-virtual-grid>
        </div>
      </div>
    </div>

    <div *ngIf="!(hasData$| async)  && dataLoaded" class="empty-content flex flex-col flex-1-0-100">
      <div class="text-container">
        <img
          src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/reports-empty.png"
          alt="Empty images">
        <h1>No changes found</h1>
        <div class="text">We couldn't find any changes for your chosen period and settings. Try adjusting the date
          range,
          change types or topic/country selections.
        </div>
      </div>
    </div>
  </div>

  <div class="page-separator"></div>
  <div class="p-t-30 flex flex-col justify-start items-start full-grow-no-shrink-no-basis ">
    <div class="hide-message flex flex-row justify-end items-center">
      <!--  <a href="#">
          Hide this message
        </a>-->
    </div>
    <div class="map-container w-p-100 flex flex-row justify-start items-start full-grow-no-shrink-no-basis ">
      <particle-dashboard-hitmap></particle-dashboard-hitmap>
    </div>
  </div>
</div>
